import { render } from "./MethodsTab.vue?vue&type=template&id=e9ecf16e&scoped=true"
import script from "./MethodsTab.vue?vue&type=script&lang=js"
export * from "./MethodsTab.vue?vue&type=script&lang=js"

import "./MethodsTab.vue?vue&type=style&index=0&id=e9ecf16e&scoped=true&lang=css"

import exportComponent from "/home/ubuntu/dynamic-builder/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9ecf16e"]])

export default __exports__